export enum ACTIVITY_TYPE {
  DEAL_SEARCH = 'deal_search',
  DEAL_VIEW = 'deal_view',
}
